import React from "react";

const updatedDate = "May 16, 2026";

const styles = {
    page: {
        minHeight: "100vh",
        background:
            "radial-gradient(circle at top left, rgba(197,155,69,0.12), transparent 32%), radial-gradient(circle at top right, rgba(5,7,19,0.10), transparent 30%), linear-gradient(to bottom, #F7F8FA, #F2F3F5 45%, #F7F8FA)",
        color: "#0F172A",
        padding: "72px 20px",
        fontFamily:
            "Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif",
    },
    container: {
        maxWidth: "1040px",
        margin: "0 auto",
        lineHeight: 1.75,
    },
    badge: {
        display: "inline-flex",
        alignItems: "center",
        padding: "6px 12px",
        borderRadius: "999px",
        background: "#FFF9EA",
        color: "#7A5A17",
        border: "1px solid #E7D8AC",
        fontSize: "12px",
        fontWeight: 700,
        letterSpacing: "0.16em",
        textTransform: "uppercase",
        marginBottom: "18px",
    },
    h1: {
        fontSize: "clamp(32px, 4vw, 48px)",
        lineHeight: 1.08,
        margin: "0 0 14px",
        letterSpacing: "-0.04em",
        color: "#050713",
        fontWeight: 700,
    },
    updated: {
        color: "#64748B",
        marginBottom: "34px",
        fontSize: "14px",
    },
    h2: {
        fontSize: "18px",
        marginTop: "30px",
        marginBottom: "10px",
        color: "#050713",
        letterSpacing: "-0.015em",
        fontWeight: 700,
    },
    p: {
        color: "#475569",
        margin: "0 0 14px",
        fontSize: "15px",
    },
    ul: {
        color: "#475569",
        paddingLeft: "22px",
        marginTop: "8px",
        fontSize: "15px",
    },
    box: {
        border: "1px solid #E2E8F0",
        background: "#FFFFFF",
        borderRadius: "24px",
        padding: "24px",
        margin: "24px 0 32px",
        boxShadow: "0 18px 55px rgba(15, 23, 42, 0.06)",
    },
    document: {
        border: "1px solid #E2E8F0",
        background: "#FFFFFF",
        borderRadius: "30px",
        padding: "32px",
        boxShadow: "0 18px 55px rgba(15, 23, 42, 0.06)",
    },
    link: {
        color: "#7A5A17",
        textDecoration: "none",
        fontWeight: 700,
    },
};

export default function Terms() {
    return (
        <main style={styles.page}>
            <section style={styles.container}>
                <div style={styles.badge}>Krionex Legal</div>

                <h1 style={styles.h1}>Terms of Service</h1>
                <p style={styles.updated}>Last updated: {updatedDate}</p>

                <div style={styles.box}>
                    <p style={styles.p}>
                        These Terms of Service govern your access to and use of Krionex,
                        including our website, application, APIs, smart contract deployment
                        tools, token creation tools, minting features, dashboards, billing
                        features, and related services.
                    </p>
                    <p style={styles.p}>
                        By accessing or using Krionex, connecting a wallet, creating an
                        account, deploying a contract, minting an asset, or purchasing a
                        subscription, you agree to these Terms.
                    </p>
                </div>
                <div style={styles.document}>
                    <h2 style={styles.h2}>1. About Krionex</h2>
                    <p style={styles.p}>
                        Krionex is a developer infrastructure platform that helps users create,
                        configure, deploy, manage, and monitor blockchain-based assets and
                        smart contracts. Krionex may support features such as token deployment,
                        smart contract deployment, minting, deployment history, wallet-based
                        access, network selection, and related blockchain operations.
                    </p>
                    <p style={styles.p}>
                        Krionex is a software tooling platform. Krionex is not a financial
                        institution, broker, exchange, investment advisor, legal advisor, tax
                        advisor, custodian, or wallet provider.
                    </p>

                    <h2 style={styles.h2}>2. Eligibility</h2>
                    <p style={styles.p}>
                        You may use Krionex only if you are legally permitted to do so in your
                        jurisdiction and are able to enter into a binding agreement. You are
                        responsible for ensuring that your use of Krionex complies with all
                        applicable laws, rules, and regulations.
                    </p>

                    <h2 style={styles.h2}>3. Accounts, Wallets, and Access</h2>
                    <p style={styles.p}>
                        Some Krionex features may require you to connect a blockchain wallet,
                        sign messages, authenticate, or create an account. You are solely
                        responsible for maintaining the security of your wallet, private keys,
                        seed phrases, devices, accounts, passwords, and connected services.
                    </p>
                    <p style={styles.p}>
                        Krionex does not control your wallet and cannot recover lost private
                        keys, reverse wallet signatures, restore access to compromised wallets,
                        or recover blockchain assets transferred by mistake.
                    </p>

                    <h2 style={styles.h2}>4. Smart Contract Deployment and Minting</h2>
                    <p style={styles.p}>
                        You are solely responsible for all smart contracts, tokens, metadata,
                        minting actions, deployment configurations, contract parameters,
                        wallet signatures, and blockchain transactions created or initiated
                        through Krionex.
                    </p>
                    <p style={styles.p}>
                        If you use Krionex to deploy tokens, mint assets, create NFTs,
                        configure ownership, assign supply, update metadata, or perform
                        similar blockchain actions, you represent that you have all necessary
                        rights, permissions, licenses, and legal authority to do so.
                    </p>
                    <p style={styles.p}>
                        Krionex does not verify the legality, regulatory status, ownership,
                        intellectual property rights, securities status, tax treatment, or
                        commercial suitability of any contract, token, mint, metadata, image,
                        name, symbol, supply, or asset created by users.
                    </p>

                    <h2 style={styles.h2}>5. User-Controlled Minting, Supply, and Token Actions</h2>
                    <p style={styles.p}>
                        Krionex provides software tools that may allow users to configure token
                        supply, deploy mintable contracts, mint additional assets, burn assets, pause
                        contracts, unpause contracts, assign roles, or perform other token-related
                        actions where supported by the selected contract configuration.
                    </p>
                    <p style={styles.p}>
                        All minting, supply decisions, token issuance, token distribution, metadata
                        choices, recipient addresses, royalty settings, role assignments, and related
                        blockchain actions are controlled by the user and confirmed through the
                        user’s wallet. Krionex does not independently authorize, approve, supervise,
                        limit, validate, or monitor the legal purpose of user-created tokens or user
                        minting activity.
                    </p>
                    <p style={styles.p}>
                        You are solely responsible for ensuring that any token supply, minting volume,
                        NFT issuance, asset distribution, metadata, collection name, symbol, image,
                        description, royalty configuration, and token-related activity complies with
                        applicable laws, regulations, platform rules, intellectual property rights,
                        consumer protection rules, securities laws, tax obligations, and any other
                        legal requirements that apply to you.
                    </p>
                    <p style={styles.p}>
                        Krionex is not responsible for excessive minting, unauthorized minting,
                        misleading supply, inflationary token behavior, user-created tokenomics,
                        market impact, buyer expectations, token sales, community claims, third-party
                        marketplace listings, or any legal, financial, regulatory, or reputational
                        consequences arising from tokens, NFTs, metadata, or assets created by users.
                    </p>
                    <p style={styles.p}>
                        If you enable mintable, burnable, pausable, royalty, or administrative
                        features, you are responsible for understanding how those features work and
                        for controlling access to any owner, admin, minter, burner, pauser, or similar
                        role. Krionex is not liable for misuse, compromised wallets, incorrect role
                        assignment, unauthorized actions caused by your wallet or account security,
                        or actions performed by wallets that have been granted permissions.
                    </p>

                    <h2 style={styles.h2}>6. Blockchain Risks</h2>
                    <p style={styles.p}>
                        Blockchain transactions are generally irreversible. Once a transaction
                        is submitted, deployed, minted, confirmed, or recorded on a blockchain,
                        Krionex may not be able to cancel, modify, delete, reverse, hide, or
                        recover it.
                    </p>
                    <p style={styles.p}>
                        You acknowledge that blockchain networks may experience congestion,
                        high gas fees, failed transactions, delayed confirmations, chain
                        reorganizations, RPC failures, wallet errors, validator issues,
                        explorer delays, or other technical problems outside Krionex’s control.
                    </p>
                    <p style={styles.p}>
                        Gas fees, network fees, validator fees, and other blockchain-related
                        charges are paid to blockchain networks or third-party infrastructure,
                        not to Krionex, and are generally non-refundable.
                    </p>

                    <h2 style={styles.h2}>7. Network, Wallet, and User-Side Issues</h2>
                    <p style={styles.p}>
                        Krionex is not responsible for failed, delayed, duplicated, rejected,
                        or incomplete actions caused by user-side or third-party issues,
                        including poor internet connection, browser errors, device issues,
                        wallet connection failures, rejected wallet signatures, incorrect
                        network selection, insufficient gas, RPC outages, wallet provider
                        outages, block explorer delays, or blockchain network congestion.
                    </p>
                    <p style={styles.p}>
                        You are responsible for confirming wallet prompts, selecting the
                        correct blockchain network, maintaining a stable internet connection,
                        reviewing transaction details before signing, and verifying transaction
                        status through your wallet, blockchain explorer, or relevant network
                        tools.
                    </p>

                    <h2 style={styles.h2}>8. Privacy Controls and Deployment History</h2>
                    <p style={styles.p}>
                        Krionex may provide privacy controls that allow users to hide
                        deployment records, contract addresses, transaction hashes, or related
                        history from their Krionex workspace or Krionex-controlled interfaces.
                    </p>
                    <p style={styles.p}>
                        These privacy controls do not remove, erase, hide, anonymize, or
                        modify public blockchain records. Blockchain transactions, wallet
                        addresses, contract addresses, transaction hashes, token activity, and
                        related data may remain publicly visible through blockchain networks,
                        RPC providers, explorers, indexers, analytics platforms, and other
                        third-party services.
                    </p>

                    <h2 style={styles.h2}>9. Prohibited Uses</h2>
                    <p style={styles.p}>You may not use Krionex to create, support, or facilitate:</p>
                    <ul style={styles.ul}>
                        <li>fraud, scams, phishing, impersonation, or deceptive activity;</li>
                        <li>money laundering, terrorist financing, sanctions evasion, or illegal payments;</li>
                        <li>illegal securities offerings, market manipulation, or misleading token launches;</li>
                        <li>malware, exploits, unauthorized access, or attacks on networks or users;</li>
                        <li>content or assets that violate intellectual property, privacy, or publicity rights;</li>
                        <li>illegal gambling, illegal financial products, or prohibited regulated activity;</li>
                        <li>activity that violates applicable laws, regulations, or third-party rights.</li>
                    </ul>
                    <p style={styles.p}>
                        Krionex may suspend or restrict access to accounts, deployments,
                        workspaces, or features if we believe the platform is being misused or
                        if continued access creates legal, security, compliance, or operational
                        risk.
                    </p>

                    <h2 style={styles.h2}>10. Security</h2>
                    <p style={styles.p}>
                        You agree not to interfere with, disrupt, reverse engineer, overload,
                        scrape, exploit, bypass, or compromise Krionex, its APIs, servers,
                        authentication systems, billing systems, smart contract tooling,
                        security controls, or connected infrastructure.
                    </p>
                    <p style={styles.p}>
                        You must not attempt to gain unauthorized access to another user’s
                        account, workspace, wallet-connected session, deployment history,
                        billing data, or private configuration.
                    </p>
                    <p style={styles.p}>
                        If you discover a security issue, you should report it responsibly to{" "}
                        <a style={styles.link} href="mailto:support@krionex.com">
                            support@krionex.com
                        </a>{" "}
                        and avoid public disclosure until Krionex has had a reasonable
                        opportunity to investigate and address the issue.
                    </p>

                    <h2 style={styles.h2}>11. Payments, Subscriptions, and Billing</h2>
                    <p style={styles.p}>
                        Some Krionex features may require payment or an active subscription.
                        Pricing, plan limits, billing intervals, and included features may be
                        shown on the Krionex website or checkout page.
                    </p>
                    <p style={styles.p}>
                        By purchasing a paid plan, you authorize Krionex or its payment
                        processor to charge your selected payment method for applicable fees,
                        taxes, renewals, and other charges associated with your plan.
                    </p>
                    <p style={styles.p}>
                        You are responsible for maintaining accurate billing information and
                        for any charges incurred through your account or workspace.
                    </p>

                    <h2 style={styles.h2}>12. Cancellations and Refunds</h2>
                    <p style={styles.p}>
                        You may cancel your subscription according to the cancellation options
                        available in Krionex, through the Paddle customer portal, or through our
                        support process. Unless otherwise stated, cancellation prevents future
                        renewal but does not refund prior charges or the current billing period.
                    </p>
                    <p style={styles.p}>
                        Subscription fees for the current billing period are generally
                        non-refundable once paid. Users are responsible for canceling before the
                        next renewal date if they do not want to be charged for the next billing
                        period.
                    </p>
                    <p style={styles.p}>
                        Refunds may be reviewed only in limited cases, such as duplicate billing,
                        verified payment errors, verified technical failure caused by Krionex,
                        requirements under applicable law, Paddle policy, or approval by Krionex
                        after review.
                    </p>
                    <p style={styles.p}>
                        Krionex does not guarantee refunds for partially used billing periods,
                        unused features, user mistakes, wallet issues, deployment mistakes,
                        substantial use of paid features, or failure to cancel before renewal.
                    </p>
                    <p style={styles.p}>
                        Blockchain gas fees, network fees, validator fees, failed transaction
                        costs, contract deployment costs, minting costs, and third-party
                        infrastructure charges are non-refundable by Krionex.
                    </p>
                    <p style={styles.p}>
                        If an account is involved in misuse, fraud, security abuse, chargeback
                        abuse, prohibited activity, or violation of these Terms, Krionex may
                        suspend or revoke platform access immediately. Refunds in these cases are
                        not guaranteed and may be denied, subject to applicable law and Paddle
                        policy.
                    </p>

                    <h2 style={styles.h2}>13. No Financial, Legal, or Tax Advice</h2>
                    <p style={styles.p}>
                        Krionex does not provide financial, investment, trading, legal, tax,
                        accounting, compliance, or regulatory advice. Any information,
                        templates, configuration options, deployment flows, or documentation
                        provided by Krionex are for general software tooling purposes only.
                    </p>
                    <p style={styles.p}>
                        You should consult qualified professionals before launching tokens,
                        minting assets, selling digital assets, raising funds, or engaging in
                        regulated activity.
                    </p>

                    <h2 style={styles.h2}>14. Third-Party Services</h2>
                    <p style={styles.p}>
                        Krionex may rely on or integrate with third-party services such as
                        wallets, RPC providers, blockchain networks, payment processors,
                        analytics tools, authentication providers, infrastructure providers,
                        explorers, and cloud services.
                    </p>
                    <p style={styles.p}>
                        Krionex is not responsible for third-party services, their availability,
                        security, fees, errors, data practices, terms, or actions.
                    </p>

                    <h2 style={styles.h2}>15. Service Availability</h2>
                    <p style={styles.p}>
                        Krionex may update, modify, suspend, limit, or discontinue parts of the
                        platform at any time. We do not guarantee uninterrupted availability,
                        error-free operation, permanent storage of deployment history, or
                        compatibility with every wallet, browser, RPC provider, chain, token
                        standard, or smart contract.
                    </p>

                    <h2 style={styles.h2}>16. Intellectual Property</h2>
                    <p style={styles.p}>
                        Krionex, including its software, interface, branding, designs,
                        documentation, workflows, and platform content, is owned by Krionex or
                        its licensors. You may not copy, modify, distribute, sell, or misuse
                        Krionex’s intellectual property except as permitted by these Terms or
                        applicable law.
                    </p>
                    <p style={styles.p}>
                        You retain responsibility for content, metadata, names, symbols,
                        images, descriptions, and other materials you upload, submit, deploy,
                        mint, or configure through Krionex.
                    </p>

                    <h2 style={styles.h2}>17. Disclaimers</h2>
                    <p style={styles.p}>
                        Krionex is provided on an “as is” and “as available” basis. To the
                        fullest extent permitted by law, Krionex disclaims all warranties,
                        express or implied, including warranties of merchantability, fitness
                        for a particular purpose, non-infringement, availability, accuracy,
                        security, and reliability.
                    </p>

                    <h2 style={styles.h2}>18. Limitation of Liability</h2>
                    <p style={styles.p}>
                        To the fullest extent permitted by law, Krionex will not be liable for
                        indirect, incidental, special, consequential, exemplary, or punitive
                        damages, or for loss of profits, revenue, assets, tokens, data,
                        goodwill, business opportunities, or expected savings.
                    </p>
                    <p style={styles.p}>
                        Krionex is not liable for losses caused by wallet compromise, private
                        key loss, user error, incorrect configuration, failed transactions,
                        gas fees, blockchain network issues, third-party services, smart
                        contract vulnerabilities, regulatory actions, or unauthorized use of
                        your account or wallet.
                    </p>

                    <h2 style={styles.h2}>19. Indemnification</h2>
                    <p style={styles.p}>
                        You agree to defend, indemnify, and hold harmless Krionex from claims,
                        damages, losses, liabilities, costs, and expenses arising from your use
                        of the platform, your deployments, your minted assets, your tokens,
                        your violation of these Terms, your violation of law, or your violation
                        of third-party rights.
                    </p>

                    <h2 style={styles.h2}>20. Changes to These Terms</h2>
                    <p style={styles.p}>
                        Krionex may update these Terms from time to time. The updated version
                        will be posted on this page with a revised “Last updated” date. Your
                        continued use of Krionex after changes become effective means you
                        accept the updated Terms.
                    </p>

                    <h2 style={styles.h2}>21. Contact</h2>
                    <p style={styles.p}>
                        For questions about these Terms, contact us at{" "}
                        <a style={styles.link} href="mailto:support@krionex.com">
                            support@krionex.com
                        </a>
                        .
                    </p>
                </div>
            </section>
        </main>
    );
}